<template>
<v-layout fill-height column>

    <v-toolbar class="px-5" color="blue lighten-3" dense>
        <v-toolbar-title class="cursor-pointer" @click="$router.push({ name: 'AdminDashboard' })">
            <v-icon>supervised_user_circle</v-icon>
            {{ user.first_name }} {{ user.last_name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <v-menu transition="slide-y-transition" bottom>
                <v-btn flat slot="activator">Classes<v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list class="blue lighten-5" subheader>
                    <v-list-tile @click="$router.push({ name: 'AdminCreateClass'})">
                        <v-list-tile-title>Create Class</v-list-tile-title>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-subheader>Semester</v-subheader>
                    <v-list-tile v-for="semester in semesters" :key="semester.id" @click="$router.push({ name: 'AdminClasses', params: { semester_slug: semester.slug } })">
                        <v-list-tile-title>{{ semester.name }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <!-- <v-btn flat @click="$router.push({ name: 'AdminSemesters' })">Semesters</v-btn> -->
            <v-menu transition="slide-y-transition" bottom>
                <v-btn flat slot="activator">Semesters<v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list class="blue lighten-5" subheader>
                    <v-list-tile @click="$router.push({ name: 'AdminCreateSemester'})">
                        <v-list-tile-title>Create Semester</v-list-tile-title>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-subheader>Semester</v-subheader>
                    <v-list-tile v-for="semester in semesters" :key="semester.id" @click="$router.push({ name: 'AdminEditSemester', params: { semester_slug: semester.slug } })">
                        <v-list-tile-title>{{ semester.name }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-menu transition="slide-y-transition" bottom>
                <v-btn flat slot="activator">Enrollment Logs<v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list class="blue lighten-5" subheader>
                    <v-subheader>Semester</v-subheader>
                    <v-list-tile v-for="semester in semesters" :key="semester.id" @click="$router.push({ name: 'AdminLogs', params: { semester_slug: semester.slug } })">
                        <v-list-tile-title>{{ semester.name }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-menu transition="slide-y-transition" bottom>
                <v-btn flat slot="activator">Users<v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list class="blue lighten-5">
                    <v-list-tile @click="$router.push({ name: 'AdminStudents' })">
                        <v-list-tile-title>Students</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="$router.push({ name: 'AdminTeachers' })">
                        <v-list-tile-title>Teachers</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="$router.push({ name: 'AdminParents' })">
                        <v-list-tile-title>Parents</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-btn flat @click="$router.push({ name: 'SystemNotifications' })">System Notifications</v-btn>

        </v-toolbar-items>
    </v-toolbar>

    <v-container>
        <v-layout row wrap align-center fill-height>
            <slot></slot>
        </v-layout>
    </v-container>

</v-layout>
</template>

<script>
  export default {
      computed: {
          user() {
              return this.$store.state.auth.user
          },
          semesters() {
              return this.$store.getters.semestersRouterFormat
          }
      },
      beforeCreate() {
          this.$store.dispatch('getSemesters')
      }
  }
</script>

<style>
.cursor-pointer:hover {
    cursor: pointer;
}
</style>
